import { Tooltip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import OpenInNewRoundedIcon from "@material-ui/icons/OpenInNewRounded";
import React from "react";

import { useCardWidgetStyles } from "./cardWidgetStyles";

interface Props {
    url: string;
    enabled: boolean;
}

const useDisabledStyles = makeStyles(() => ({
    disabled: {
        opacity: 0.5,
        cursor: "not-allowed",
    },
}));

export function OpenCommissioningSiteWidget({ url, enabled }: Props) {
    const classes = useCardWidgetStyles();
    const disabledClasses = useDisabledStyles();

    if (!enabled) {
        return (
            <Tooltip title="Enable maintenance mode to access this link">
                <span className={`${classes.container} ${disabledClasses.disabled}`} aria-disabled="true">
                    <div className={classes.summary}>
                        <OpenInNewRoundedIcon className={classes.icon} />
                        <Typography className={classes.descr}>Open Commissioning Site</Typography>
                    </div>
                </span>
            </Tooltip>
        );
    }

    return (
        <a
            className={classes.container}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Open Commissioning Site in new tab"
        >
            <div className={classes.summary}>
                <OpenInNewRoundedIcon className={classes.icon} />
                <Typography className={classes.descr}>Open Commissioning Site</Typography>
            </div>
        </a>
    );
}
